import { render, staticRenderFns } from "./Chatroom.vue?vue&type=template&id=c8ad55fa&scoped=true&"
import script from "./Chatroom.vue?vue&type=script&lang=js&"
export * from "./Chatroom.vue?vue&type=script&lang=js&"
import style0 from "./Chatroom.vue?vue&type=style&index=0&id=c8ad55fa&scoped=true&lang=css&"
import style1 from "./Chatroom.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ad55fa",
  null
  
)

export default component.exports